module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"start":"Let\u0027s go!"},"fi":{"start":"Aloitetaan!"},"sv":{"start":"Då börjar vi!"},"de":{"start":"Los geht\u0027s!"},"ko":{"start":"시작하기"}}')
  delete Component.options._Ctor
}
